import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-classroom-admin",
	templateUrl: "./classroom-admin.component.html",
	styleUrls: ["./classroom-admin.component.css"],
})
export class ClassroomAdminComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////
	SectionScheduleDetailID: any = -1;
	SelectDate: any = new Date();
	SchoolID: any = -1;

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////
	onSectionSelected(val) {
		if (val == null) {
			this.SectionScheduleDetailID = -1;
			this.SelectDate = new Date();
			this.SchoolID = -1;
		} else {
			this.SectionScheduleDetailID = val.SectionScheduleDetailID;
			this.SelectDate = val.SelectDate;
			this.SchoolID = val.SchoolID;
		}
	}
	////////////////////////////////////////////////
}
